(function () {
  'use strict';

  if (window.HazelStockLimitToast) return;

  var TOAST_ID = 'hz-stock-limit-toast';
  var STYLE_ID = 'hz-stock-limit-toast-styles';
  var lastToastAt = 0;
  var toastTimer = null;
  var DEFAULT_STOCK_MESSAGE = "Only 1 item is left in stock!";
  var LIMIT_MESSAGE = "The requested quantity exceeds the available stock.";

  function isExemptPath() {
    return /\/pages\/build-your-own-hamper(?:\/|$)/i.test(window.location.pathname || '');
  }

  function showToast(message) {
    if (isExemptPath()) return;
    lastToastAt = Date.now();

    if (!document.getElementById(STYLE_ID)) {
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent =
        '#' + TOAST_ID + '{' +
          'position:fixed;top:1rem;left:50%;transform:translate(-50%,-0.5rem);' +
          'z-index:2147483647;max-width:min(92vw,38rem);width:max-content;' +
          'box-sizing:border-box;padding:.85rem 1.15rem;border-radius:.65rem;' +
          'background:#3b2a1a;color:#f4ead0;border:1px solid #d9c7a5;' +
          'box-shadow:0 .5rem 1.5rem rgba(0,0,0,.2);' +
          'font-family:inherit;font-size:.92rem;font-weight:600;line-height:1.45;' +
          'text-align:center;opacity:0;visibility:hidden;pointer-events:none;' +
          'transition:opacity .18s ease,transform .18s ease,visibility .18s ease;' +
        '}' +
        '#' + TOAST_ID + '.is-visible{opacity:1;visibility:visible;transform:translate(-50%,0);}' +
        '@media(prefers-reduced-motion:reduce){#' + TOAST_ID + '{transition:none;}}';
      document.head.appendChild(style);
    }

    var toast = document.getElementById(TOAST_ID);
    if (!toast) {
      toast = document.createElement('div');
      toast.id = TOAST_ID;
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }

    toast.textContent = message || DEFAULT_STOCK_MESSAGE;
    toast.classList.remove('is-visible');
    window.requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    if (toastTimer) window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3600);
  }

  function applyStockAttributes(element, variantId, inventoryQuantity, inventoryManagement, inventoryPolicy) {
    if (!element) return;
    var tracked = !!inventoryManagement && inventoryPolicy !== 'continue';
    var quantity = parseInt(inventoryQuantity, 10);
    if (!Number.isFinite(quantity)) quantity = 0;
    quantity = Math.max(0, quantity);

    element.setAttribute('data-hz-stock-limit', tracked ? 'true' : 'false');
    element.setAttribute('data-hz-stock-quantity', String(quantity));
    if (variantId != null) element.setAttribute('data-variant-id', String(variantId));
  }

  function setVariantStock(variantId, inventoryQuantity, inventoryManagement, inventoryPolicy) {
    if (isExemptPath() || variantId == null) return;
    var id = String(variantId);

    document.querySelectorAll('[data-variant-id]').forEach(function (element) {
      if (String(element.getAttribute('data-variant-id')) === id) {
        applyStockAttributes(element, id, inventoryQuantity, inventoryManagement, inventoryPolicy);
      }
    });

    var productWrapper = document.querySelector('#AddToCartForm .hz-product-cart-action');
    if (productWrapper) {
      applyStockAttributes(productWrapper, id, inventoryQuantity, inventoryManagement, inventoryPolicy);
    }
  }

  function getStockElement(target) {
    if (!target || !target.closest) return null;

    var marked = target.closest('[data-hz-stock-limit]');
    if (marked) return marked;

    var form = target.closest('form');
    if (form) {
      if (form.hasAttribute('data-hz-stock-limit')) return form;
      var productWrapper = form.querySelector('.hz-product-cart-action[data-hz-stock-limit]');
      if (productWrapper) return productWrapper;
    }

    var row = target.closest('tr');
    if (row) return row.querySelector('input[data-hz-stock-limit]');
    return null;
  }

  function readStock(target) {
    var element = getStockElement(target);
    if (!element) return null;
    var enforced = element.getAttribute('data-hz-stock-limit') === 'true';
    var max = parseInt(element.getAttribute('data-hz-stock-quantity'), 10);
    if (!Number.isFinite(max)) max = 0;
    max = Math.max(0, max);
    var variantId = element.getAttribute('data-variant-id') || '';
    return { element: element, enforced: enforced, max: max, variantId: variantId };
  }

  function numericValue(element) {
    if (!element) return 0;
    var value = parseInt(element.value != null ? element.value : element.textContent, 10);
    return Number.isFinite(value) && value > 0 ? value : 0;
  }

  function stockLimitMessage(current, max, alreadyInCart) {
    if (max <= 0) return 'This product is currently out of stock.';
    if (max === 1) return 'Only 1 item is left in stock!';
    return 'Only ' + max + ' items are left in stock!';
  }

  function stockLimitMessageForVariant(variantId, fallbackTarget) {
    var requestedId = variantId == null ? '' : String(variantId);
    if (requestedId) {
      var matchedQuantity = null;
      document.querySelectorAll('[data-hz-stock-limit="true"][data-variant-id]').forEach(function (element) {
        if (String(element.getAttribute('data-variant-id')) !== requestedId) return;
        var quantity = parseInt(element.getAttribute('data-hz-stock-quantity'), 10);
        if (!Number.isFinite(quantity)) quantity = 0;
        matchedQuantity = Math.max(0, quantity);
      });
      if (matchedQuantity !== null) return stockLimitMessage(0, matchedQuantity, false);
    }

    var activeStock = readStock(fallbackTarget || document.activeElement);
    if (activeStock && activeStock.enforced) {
      return stockLimitMessage(0, activeStock.max, false);
    }
    return LIMIT_MESSAGE;
  }

  function extractVariantId(url, body) {
    var id = '';

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      id = body.get('id') || body.get('variant_id') || '';
    } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      id = body.get('id') || body.get('variant_id') || '';
    } else if (body && typeof body === 'object') {
      id = body.id != null ? body.id : (body.variant_id != null ? body.variant_id : '');
    } else if (typeof body === 'string' && body) {
      try {
        var parsedBody = JSON.parse(body);
        id = parsedBody.id != null ? parsedBody.id : (parsedBody.variant_id != null ? parsedBody.variant_id : '');
      } catch (error) {
        try {
          var params = new URLSearchParams(body);
          id = params.get('id') || params.get('variant_id') || '';
        } catch (parseError) {}
      }
    }

    if (!id && url) {
      try {
        var parsedUrl = new URL(url, window.location.href);
        id = parsedUrl.searchParams.get('id') || parsedUrl.searchParams.get('variant_id') || '';
      } catch (error) {}
    }

    return id == null ? '' : String(id);
  }

  function stopClick(event, message) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    showToast(message);
  }

  function getCartUrl() {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'cart.js';
  }

  function updateStickyForm(form) {
    if (!form || !form.matches('.product-addtocart-sticky')) return;
    var select = form.querySelector('select[name="id"]');
    if (!select || select.selectedIndex < 0) return;
    var option = select.options[select.selectedIndex];
    if (!option) return;
    form.setAttribute('data-variant-id', option.value);
    form.setAttribute('data-hz-stock-limit', option.getAttribute('data-hz-stock-limit') || 'false');
    form.setAttribute('data-hz-stock-quantity', option.getAttribute('data-hz-stock-quantity') || '0');
  }

  function initStickyForms() {
    document.querySelectorAll('.product-addtocart-sticky').forEach(updateStickyForm);
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    if (target.matches('#quickViewModal select[name="id"], #quickViewModal input[name="id"]')) {
      var quickViewForm = target.closest('form');
      var quickViewOption = target.tagName === 'SELECT'
        ? target.options[target.selectedIndex]
        : target;
      if (quickViewForm && quickViewOption) {
        quickViewForm.setAttribute('data-variant-id', target.value || '');
        quickViewForm.setAttribute('data-hz-stock-limit', quickViewOption.getAttribute('data-hz-stock-limit') || 'false');
        quickViewForm.setAttribute('data-hz-stock-quantity', quickViewOption.getAttribute('data-hz-stock-quantity') || '0');
      }
      return;
    }

    if (target.matches('.product-addtocart-sticky select[name="id"]')) {
      updateStickyForm(target.closest('form'));
      return;
    }

    if (target.matches('input[data-hz-stock-limit="true"][name="updates[]"]')) {
      var stock = readStock(target);
      var requested = numericValue(target);
      if (stock && stock.enforced && requested > stock.max) {
        target.value = String(stock.max);
        showToast(stockLimitMessage(stock.max, stock.max, true));
      }
    }
  });

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element) || isExemptPath()) return;
    var target = event.target;

    var gridPlus = target.closest('.hz-grid-qty-plus');
    if (gridPlus) {
      var gridBlock = gridPlus.closest('.hz-grid-cart-action');
      var gridStock = readStock(gridBlock || gridPlus);
      if (gridStock && gridStock.enforced) {
        var gridDisplay = gridBlock && gridBlock.querySelector('.hz-grid-qty-value');
        var gridCurrent = gridBlock && Number.isFinite(Number(gridBlock._hzQuantity))
          ? Math.max(0, parseInt(gridBlock._hzQuantity, 10) || 0)
          : numericValue(gridDisplay);
        if (gridCurrent + 1 > gridStock.max) {
          stopClick(event, stockLimitMessage(gridCurrent, gridStock.max, true));
          return;
        }
      }
    }

    var productPlus = target.closest('.hz-product-qty-plus');
    if (productPlus) {
      var productBlock = productPlus.closest('.hz-product-cart-action');
      var productStock = readStock(productBlock || productPlus);
      if (productStock && productStock.enforced) {
        var productDisplay = productBlock && productBlock.querySelector('.hz-product-qty-value');
        var productCurrent = numericValue(productDisplay);
        if (productCurrent + 1 > productStock.max) {
          stopClick(event, stockLimitMessage(productCurrent, productStock.max, true));
          return;
        }
      }
    }

    var addButton = target.closest('.hz-grid-add-btn');
    if (addButton) {
      var addBlock = addButton.closest('.hz-grid-cart-action');
      var addStock = readStock(addBlock || addButton);
      if (addStock && addStock.enforced) {
        var addCurrent = addBlock && Number.isFinite(Number(addBlock._hzQuantity))
          ? Math.max(0, parseInt(addBlock._hzQuantity, 10) || 0)
          : 0;
        if (addCurrent + 1 > addStock.max) {
          stopClick(event, stockLimitMessage(addCurrent, addStock.max, addCurrent > 0));
          return;
        }
      }
    }

    var genericPlus = target.closest('.cart-plus-minus .qtybutton, .product-quantity .qtybutton, .ajaxcart__qty--plus');
    if (!genericPlus) return;

    var classes = String(genericPlus.className || '').toLowerCase();
    var label = String(genericPlus.textContent || '').trim();
    var aria = String(genericPlus.getAttribute('aria-label') || '').toLowerCase();
    var isIncrement = /plus|increase|increment|qtybutton--plus|inc/.test(classes) || label === '+' || /increase|plus/.test(aria);
    if (!isIncrement) return;

    var quantityWrap = genericPlus.closest('.cart-plus-minus, .product-quantity, .ajaxcart__qty, .pro-quantity');
    var quantityInput = quantityWrap && quantityWrap.querySelector('input[name="quantity"], input[name="updates[]"], .cart-plus-minus-box, .ajaxcart__qty-num');
    var genericStock = readStock(quantityInput || genericPlus);
    if (genericStock && genericStock.enforced && quantityInput) {
      var inputCurrent = numericValue(quantityInput);
      if (inputCurrent + 1 > genericStock.max) {
        stopClick(event, stockLimitMessage(inputCurrent, genericStock.max, quantityInput.name === 'updates[]'));
      }
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || isExemptPath()) return;

    if (form.dataset.hzStockSubmitBypass === 'true') {
      delete form.dataset.hzStockSubmitBypass;
      return;
    }

    var action = String(form.getAttribute('action') || '');
    var isCartUpdate = /(?:^|\/)cart(?:\?.*)?\/?$/.test(action) || !!form.querySelector('input[name="updates[]"]');
    if (isCartUpdate) {
      var cartInputs = form.querySelectorAll('input[name="updates[]"][data-hz-stock-limit="true"]');
      for (var i = 0; i < cartInputs.length; i++) {
        var cartInput = cartInputs[i];
        var stock = readStock(cartInput);
        var requested = numericValue(cartInput);
        if (stock && stock.enforced && requested > stock.max) {
          event.preventDefault();
          event.stopImmediatePropagation();
          cartInput.value = String(stock.max);
          showToast(stockLimitMessage(stock.max, stock.max, true));
          return;
        }
      }
      return;
    }

    if (!/\/cart\/add(?:\.js)?(?:\?|$)/.test(action) && !/\/cart\/add(?:\.js)?(?:\?|$)/.test(form.action || '')) return;

    var stockInfo = readStock(form);
    if (!stockInfo || !stockInfo.enforced || !stockInfo.variantId) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var submitter = event.submitter || null;
    var requestedQuantity = Math.max(1, numericValue(form.querySelector('[name="quantity"]')) || 1);
    fetch(getCartUrl(), { credentials: 'same-origin', headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (response) { if (!response.ok) throw new Error('Unable to verify cart stock.'); return response.json(); })
      .then(function (cart) {
        var current = 0;
        (cart && Array.isArray(cart.items) ? cart.items : []).forEach(function (item) {
          if (String(item.variant_id) !== String(stockInfo.variantId)) return;
          var properties = item.properties || {};
          if (properties['Part of'] === 'Build Your Own Hamper' || properties['Hamper ID']) return;
          current += parseInt(item.quantity, 10) || 0;
        });

        if (current + requestedQuantity > stockInfo.max) {
          showToast(stockLimitMessage(current, stockInfo.max, current >= stockInfo.max));
          return;
        }

        form.dataset.hzStockSubmitBypass = 'true';
        if (typeof form.requestSubmit === 'function') {
          if (submitter) form.requestSubmit(submitter);
          else form.requestSubmit();
        } else {
          form.submit();
        }
      })
      .catch(function () {
        /* If stock cannot be checked, let Shopify's own inventory validation handle the request. */
        form.dataset.hzStockSubmitBypass = 'true';
        if (typeof form.requestSubmit === 'function') {
          if (submitter) form.requestSubmit(submitter);
          else form.requestSubmit();
        } else {
          form.submit();
        }
      });
  }, true);

  function isInventoryErrorText(value) {
    var text = '';
    if (typeof value === 'string') text = value;
    else if (value && typeof value.message === 'string') text = value.message;
    else if (value && typeof value.description === 'string') text = value.description;
    text = text.toLowerCase();
    return /out of stock|inventory|available stock|available quantity|stock limit|sold out|already in your cart|cannot add|can't add|can only add|only\s+\d+|quantity.{0,40}(available|limit|stock)|(?:available|stock).{0,40}quantity|exceed.{0,30}(stock|available|inventory)|not enough stock/.test(text);
  }

  function parseXhrData(xhr) {
    try { return JSON.parse(xhr && xhr.responseText ? xhr.responseText : '{}'); }
    catch (error) { return {}; }
  }

  function handleXhrError(xhr, settings) {
    if (!xhr || Number(xhr.status) !== 422) return false;
    var data = parseXhrData(xhr);
    var combined = [
      data.description || '',
      data.message || '',
      data.errors ? JSON.stringify(data.errors) : '',
      xhr.responseText || ''
    ].join(' ');
    if (!isInventoryErrorText(combined)) return false;
    var variantId = extractVariantId(settings && settings.url, settings && settings.data);
    showToast(stockLimitMessageForVariant(variantId, document.activeElement));
    return true;
  }

  function wasRecentlyShown() {
    return Date.now() - lastToastAt < 3600;
  }

  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var cartMutation = /(?:^|\/)cart\/(?:add|change|update)(?:\.js)?(?:\?|$)/i.test(url);
      return originalFetch(input, init).then(function (response) {
        if (cartMutation && Number(response.status) === 422) {
          return response.clone().text().then(function (body) {
            if (isInventoryErrorText(body)) {
              var variantId = extractVariantId(url, init && init.body);
              showToast(stockLimitMessageForVariant(variantId, document.activeElement));
            }
            return response;
          }).catch(function () {
            return response;
          });
        }
        return response;
      });
    };
  }

  function attachJqueryErrorHandler() {
    if (!window.jQuery || !window.jQuery(document).on) return;
    window.jQuery(document).on('ajaxError.hzStockLimitToast', function (event, xhr, settings) {
      var url = settings && settings.url ? String(settings.url) : '';
      if (!/(?:^|\/)cart\/(?:add|change|update)(?:\.js)?(?:\?|$)/i.test(url)) return;
      handleXhrError(xhr, settings);
    });
  }

  window.HazelStockLimitToast = {
    show: showToast,
    setVariantStock: setVariantStock,
    handleXhrError: handleXhrError,
    isInventoryError: isInventoryErrorText,
    wasRecentlyShown: wasRecentlyShown
  };

  initStickyForms();
  attachJqueryErrorHandler();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initStickyForms();
      attachJqueryErrorHandler();
    }, { once: true });
  }
})();